import { styled } from '../../Utilities';
import { DetailsColumnBase } from './DetailsColumn.base';
import { getStyles } from './DetailsColumn.styles';
export var DetailsColumn = styled(DetailsColumnBase, getStyles, undefined, {
  scope: 'DetailsColumn'
});